import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import { api, assetUrl, errorText } from "@/lib/api";

const SLOTS = [
  ...Array.from({ length: 9 }, (_, i) => [`gallery-${i + 1}`, `Gallery ${i + 1}`]),
  ["about-1", "Behind the Crown — left"], ["about-2", "Behind the Crown — right"],
];

const SlotCard = ({ slot, label, src, onChange }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("Photo must be under 5 MB."); return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { const r = await api.post(`/admin/photos/${slot}`, fd); onChange(r.data); toast.success("Photo published!"); }
    catch (e) { toast.error(errorText(e)); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    try { const r = await api.delete(`/admin/photos/${slot}`); onChange(r.data); toast.success("Photo removed."); }
    catch (e) { toast.error(errorText(e)); }
  };
  return (
    <div className="slot-card" data-testid={`owner-photo-slot-${slot}`}>
      <div className="slot-frame" onClick={() => input.current?.click()}>
        {src ? <img src={assetUrl(src)} alt={label} /> : <span><ImagePlus /> Add photo</span>}
        {busy ? <span className="slot-busy">Uploading…</span> : null}
      </div>
      <input ref={input} type="file" hidden accept="image/jpeg,image/png,image/webp"
        onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid={`owner-photo-input-${slot}`} />
      <div className="slot-foot">
        <span>{label}</span>
        {src ? <button type="button" className="icon-btn" onClick={remove} aria-label={`Remove ${label}`}
          data-testid={`owner-photo-remove-${slot}`}><Trash2 size={15} /></button> : null}
      </div>
    </div>
  );
};

export const PhotosTab = () => {
  const [photos, setPhotos] = useState({});
  useEffect(() => { api.get("/photos").then((r) => setPhotos(r.data || {})).catch(() => {}); }, []);
  return (
    <section>
      <p className="owner-hint">Photos you publish here appear instantly in the Crown Gallery Polaroids and the Behind the Crown frames. JPG, PNG or WebP under 5 MB.</p>
      <div className="slot-grid">
        {SLOTS.map(([slot, label]) => <SlotCard key={slot} slot={slot} label={label} src={photos[slot]} onChange={setPhotos} />)}
      </div>
    </section>
  );
};
